<template>
  <div
    style="width: 100%; overflow: hidden; display: flex; flex-direction: column"
  >
    <el-table
      ref="tableDom"
      :data="state.tableData"
      v-loading="!Array.isArray(state.tableData)"
      element-loading-background="rgba(0, 0, 0, 0.2)"
      max-height="75vh"
      size="large"
      @row-click="onRowClick"
      style="width: 100%; border-bottom: 1px solid var(--el-table-border-color)"
      empty-text="暂无异常数据"
    >
      <el-table-column type="selection" width="55" fixed />
      <el-table-column
        label="扣缴义务人"
        type="index"
        align="center"
        min-width="100"
      >
        <template #default="{ row }">
          <el-select
            v-model="row.temp_withholding_agent_id"
            v-if="row.withholding_agent_status == 1"
            @change="onWithHoldingChange($event, row)"
            @click.stop=""
          >
            <el-option
              v-for="item in row.withholding_agent"
              :key="item"
              :label="
                '(' +
                (row.withholding_agent_type == 1
                  ? '供应商'
                  : '扣缴义务人' + ')') +
                item.withholding_agent_name
              "
              :value="item.type_id"
            ></el-option>
          </el-select>
          <text v-else>{{
            row.withholding_agent?.withholding_agent_name || "-"
          }}</text>
        </template>
      </el-table-column>
      <el-table-column
        label="证件号"
        prop="idcard"
        align="center"
        width="180"
      />
      <el-table-column
        label="异常类型"
        prop="exception_type"
        align="center"
        width="120"
      >
        <template #default="{ row }">
          <text v-if="row.exception_type == 0" style="color: #1e90ff">
            重复导入
          </text>
          <text v-else style="color: #f00">信息异常</text>
        </template>
      </el-table-column>
      <el-table-column
        label="异常说明"
        prop="exception_content"
        min-width="250"
      >
        <template #default="{ row }">
          <li v-html="row.exception_content"></li>
        </template>
      </el-table-column>
    </el-table>
    <ul
      style="
        display: flex;
        align-items: center;
        align-items: center;
        margin-top: 10px;
      "
    >
      <li style="flex: 1">
        <el-button type="primary" @click="onExport">导出</el-button>
      </li>
      <el-button type="info" @click="onSubmit(1)">取消导入</el-button>
      <el-button type="primary" @click="onSubmit(3)">仅覆盖工资</el-button>
      <el-button type="success" @click="onSubmit(4)">仅覆盖员工</el-button>
      <el-button type="danger" @click="onSubmit(2)">全部覆盖</el-button>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  payrollemployee_error_get,
  payrollemployee_error_judge,
  payrollemployee_error_submit,
  payrollemployee_error_export,
} from "@/http/payrollemployee";
import { ElMessage, ElMessageBox } from "element-plus";
export default {
  props: {
    payroll_id: Number,
  },
  setup(props, { emit }) {
    const tableDom = ref(null);
    const state = reactive({});
    onMounted(() => {
      payrollemployee_error_get(props.payroll_id).then((res) => {
        if (res.status == 200) state.tableData = res.data?.data?.list || [];
      });
    });

    const onWithHoldingChange = (value, row) => {
      const idItem = value.split("_");
      const data = {
        payroll_id: props.payroll_id,
        id: row.id,
        withholding_agent_type: idItem[0],
        withholding_agent_id: idItem[1],
      };
      payrollemployee_error_judge(data).then((res) => {
        if (res.status == 200) {
          row.exception_content = res.data?.exception_content;
          row.withholding_agent_type = idItem[0];
          row.withholding_agent_id = idItem[1];
        }
      });
    };

    const onRowClick = (row) => {
      tableDom.value.toggleRowSelection(row);
    };

    const onSubmit = (type) => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要操作的数据！",
          grouping: true,
        });
        return false;
      }

      // if (type == 2) {
      //   if (rows.some((w) => w.withholding_agent_id == 0)) {
      //     ElMessage({
      //       type: "warning",
      //       message:
      //         "已选数据中存在尚未匹配扣缴义务人的数据，操作失败，请选择后重试！",
      //       grouping: true,
      //     });
      //     return false;
      //   }
      // }

      if (type == 1) {
        ElMessageBox.confirm(
          `您确定<strong style='color:#a2a2a2'>取消导入</strong>已选<strong style='color:#1e90ff'>${rows.length}人</strong>的数据吗？`,
          "提示",
          {
            confirmButtonText: "确定取消导入",
            confirmButtonClass: "el-button--info",
            cancelButtonText: "关闭",
            type: "warning",
            dangerouslyUseHTMLString: true,
          }
        ).then(() => {
          onPost(type);
        });
      } else if (type == 2) {
        ElMessageBox.confirm(
          `您确定<strong style='color:#F56C6C'>全部覆盖</strong>已选<strong style='color:#1e90ff'>${rows.length}人</strong>的数据吗？`,
          "提示",
          {
            confirmButtonClass: "el-button--danger",
            confirmButtonText: "确定全部覆盖",
            cancelButtonText: "关闭",
            type: "warning",
            dangerouslyUseHTMLString: true,
          }
        ).then(() => {
          onPost(type);
        });
      } else if (type == 3) {
        ElMessageBox.confirm(
          `您确定<strong style='color:#409EFF'>仅覆盖工资</strong>已选<strong style='color:#1e90ff'>${rows.length}人</strong>的数据吗？`,
          "提示",
          {
            confirmButtonClass: "el-button--primary",
            confirmButtonText: "确定仅覆盖工资",
            cancelButtonText: "关闭",
            type: "warning",
            dangerouslyUseHTMLString: true,
          }
        ).then(() => {
          onPost(type);
        });
      } else if (type == 4) {
        ElMessageBox.confirm(
          `您确定<strong style='color:#67C23A'>仅覆盖员工</strong>已选<strong style='color:#1e90ff'>${rows.length}人</strong>的数据吗？`,
          "提示",
          {
            confirmButtonText: "确定仅覆盖员工",
            cancelButtonText: "关闭",
            type: "warning",
            dangerouslyUseHTMLString: true,
          }
        ).then(() => {
          onPost(type);
        });
      }
    };

    const onPost = (type) => {
      const rows = tableDom.value.getSelectionRows();
      const dataArr = rows.map((m) => {
        return {
          id: m.id,
          withholding_agent_type: m.withholding_agent_type,
          withholding_agent_id: m.withholding_agent_id,
        };
      });

      const data = {
        payroll_id: props.payroll_id,
        data: JSON.stringify(dataArr),
        deal_type: type,
      };
      payrollemployee_error_submit(data).then((res) => {
        if (res.status == 200) {
          ElMessage.success(res.data.msg);
          emit("success");
        }
      });
    };

    const onExport = () => {
      let data = { payroll_id: props.payroll_id };

      const rows = tableDom.value.getSelectionRows();
      if (rows.length > 0) {
        data.ids = rows.map((m) => m.id).join(",");
      }

      payrollemployee_error_export(data)
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1]
          );

          //通过后台返回 的word文件流设置文件名并下载
          var blob = new Blob([res.data], {
            type: res.data.type,
          });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8"
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    return {
      state,
      tableDom,
      onWithHoldingChange,
      onSubmit,
      onRowClick,
      onExport,
    };
  },
};
</script>
<style scoped></style>
